module.exports = "/fonts/vendor/pe7-icon/dist/Pe-icon-7-stroke.woff?11f7c073b050d62afb3341032ab11729";